import { useQuery } from '@apollo/client'
import type { SelectOption, SelectProps } from '@ur-solutions/react-components'
import { Select } from '@/components_deprecated'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import type {
  VehicleExpirationTypesQuery,
  VehicleExpirationTypesQueryVariables,
} from '../../types.graphql'
import { ALL_VEHICLE_EXPIRATION_TYPES_SHALLOW_QUERY } from '../../queries'
import type { VehicleExpirationTypeShallow } from '../../types'
import { getVehicleExpirationTypeName } from '../../util'

const Wrapper = styled.div`
  .--select-display-selected {
    color: ${props => props.theme.colors.text.dark};
  }
`

interface VehicleExpirationTypeSelectProps
  extends Omit<SelectProps<string>, 'options' | 'onChange'> {
  value: string | null
  onChange: (
    value: string,
    expirationType: VehicleExpirationTypeShallow | null
  ) => void
}

export const VehicleExpirationTypeSelect: React.FC<
  VehicleExpirationTypeSelectProps
> = ({ value, onChange, ...selectProps }) => {
  const { data, loading } = useQuery<
    VehicleExpirationTypesQuery,
    VehicleExpirationTypesQueryVariables
  >(ALL_VEHICLE_EXPIRATION_TYPES_SHALLOW_QUERY, {
    variables: {
      orderBy: 'name',
    },
  })

  function handleChange(
    id: string | null,
    option: SelectOption<string, VehicleExpirationTypeShallow> | null
  ) {
    if (id === null || option === null) return
    onChange(id, option.extra ?? null)
  }

  const options = useMemo<
    SelectOption<string, VehicleExpirationTypeShallow>[]
  >(() => {
    if (!data) return []

    return data.allVehicleExpirationTypes.edges.map(
      ({ node: expirationType }) => ({
        value: expirationType.id,
        label: getVehicleExpirationTypeName({ name: expirationType.name }),
        extra: expirationType,
      })
    )
  }, [data])

  return (
    <Wrapper>
      <Select
        value={value}
        options={options}
        searchable={true}
        grayed
        loading={loading}
        filterBackground="white"
        optionHoverBackground="white"
        onChange={handleChange}
        {...selectProps}
      />
    </Wrapper>
  )
}
